<template>
  <!-- Los datos de la línea de oferta desde la que se abrió la calculadora: los mismos campos que el
       bloque «DATOS DE LA OFERTA» del diseño actual, y la subcontrata igual de editable. -->
  <CalcPanel titulo="Línea de oferta" pista="Viene de la oferta desde la que se ha abierto" acento>
    <div class="col-ofg">
      <div><small>Cliente</small><b>{{ cliente || '—' }}</b></div>
      <div><small>Oferta · línea</small><b>{{ (ctx.codOferta || '—') + ' · línea ' + (ctx.numLinea != null && ctx.numLinea !== '' ? ctx.numLinea : '—') }}</b></div>
      <div><small>Servicio</small><b>{{ ctx.nombreServicio || '—' }}</b></div>
      <div><small>Materia</small><b>{{ ctx.nombreMateria || '—' }}</b></div>
      <div><small>Empleado de contratación</small><b>{{ ctx.empleadoContratacion || '—' }}</b></div>
      <div><small>Pedido</small><b>{{ ctx.codPedido || '—' }}</b></div>
      <div class="cdn-f"><label for="cdn-subc">Subcontrata (código)</label><input id="cdn-subc" :value="ctx.codSubcontrata" placeholder="Sin subcontrata" @input="$emit('set', 'codSubcontrata', $event.target.value)"></div>
      <div class="cdn-f"><label for="cdn-subn">Subcontrata (nombre)</label><input id="cdn-subn" :value="ctx.nombreSubcontrata" placeholder="—" @input="$emit('set', 'nombreSubcontrata', $event.target.value)"></div>
    </div>
  </CalcPanel>
</template>

<script>
import CalcPanel from './CalcPanel.vue';

export default {
  components: { CalcPanel },
  props: {
    ctx: { type: Object, required: true }
  },
  computed: {
    cliente: function () {
      const c = this.ctx || {};
      return (c.codCliente || '') + (c.nombreCliente ? ' · ' + c.nombreCliente : '');
    }
  }
};
</script>

<style scoped>
.col-ofg{display:grid;grid-template-columns:repeat(auto-fit,minmax(190px,1fr));gap:10px 14px}
.col-ofg>div{display:flex;flex-direction:column;gap:2px;min-width:0}
.col-ofg small{font-size:11px;color:var(--muted);font-weight:600}
.col-ofg b{font-size:13px;overflow-wrap:anywhere;color:var(--fg)}
</style>
